import { render, staticRenderFns } from "./ListArticle.vue?vue&type=template&id=4035007e&"
import script from "./ListArticle.vue?vue&type=script&lang=js&"
export * from "./ListArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports